var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReclamo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.602,
    height: 51.546,
    viewBox: "0 0 30.602 51.546",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reclamo",
    transform: "translate(17175.006 5679.78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Application",
    transform: "translate(-17167 -5677.917)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1371",
    "data-name": "Trazado 1371",
    d: "M26.738,25.595V13l-9-9h-9a3.6,3.6,0,0,0-3.6,3.6v18a3.6,3.6,0,0,0,3.6,3.6h14.4a3.6,3.6,0,0,0,3.6-3.6Z",
    transform: "translate(-5.143 -4)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1372",
    "data-name": "Trazado 1372",
    d: "M13.143,4V9.4a3.6,3.6,0,0,0,3.6,3.6h5.4",
    transform: "translate(-0.546 -4)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "!",
    transform: "matrix(0.951, -0.309, 0.309, 0.951, -17164.5, -5642.5)",
    fill: "#fff",
    fontSize: 39,
    fontFamily: "HarlowSolid, Harlow Solid"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "!")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReclamo);
export default __webpack_public_path__ + "static/media/reclamo.cdfec6c89bd6bb8996b882ede253f889.svg";
export { ForwardRef as ReactComponent };